import dayjs from 'dayjs';

export const formatDateTimeWithSeconds = (date: string) => {
  return dayjs(date).format('MMM DD, YYYY, HH:mm:ss');
};
